
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.22 7.214l-4.375-5a.627.627 0 00-.94 0l-4.375 5A.623.623 0 008 8.25h2.5v8.125c0 .345.28.625.625.625h2.5c.345 0 .625-.28.625-.625V8.25h2.5a.623.623 0 00.47-1.036z","fill":"#282E3E"}}),_c('path',{attrs:{"d":"M19.25 15.75v3.75H5.5v-3.75H3v5c0 .691.56 1.25 1.25 1.25H20.5c.691 0 1.25-.559 1.25-1.25v-5h-2.5z","fill":"#282E3E"}})])
          )
        }
      }
    